export const SET_PERMANENT_PAIRING_CODE = 'SET_PERMANENT_PAIRING_CODE';
